import StringValueObject from "@/shared/domain/value-object/StringValueObject";
export default class AuthorizationToken extends StringValueObject {
}
